<template>
  <div class="jyohouShow">
    <div class="show-msg">
      <div class="show-name"><u>東港金属・本社工場</u></div>
      <div class="card-box-Show">
        <el-row class="jyohouShow-row">
          <el-col :span="8" >
            <div class="thistitle">
            <span>{{systemName}}</span>
            </div>
          </el-col>
          <el-col :span="16" >
            <div class="thistitle">
            <span>{{yoyakuCode}}</span>
            </div>
          </el-col>
        </el-row>
        <div v-if="errorMsg !== '' && errorMsg !== null" style="font-size: 15px; color: red; margin-left: 1em">
          予約登録できましたが、メール送信は失敗しました。<br>
          予約番号は、画面を参照してください。
        </div>
        <div style="height: 700px;overflow:auto">
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">得意先コード</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{clientId}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">得意先名</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{companyName}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">運送会社名</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{truckCompName}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">得意先担当者</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{namesei}}{{'　'}}{{namemei}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="4" style="padding: 0.4em 0em 1.2em 3em">
            <div style=""></div>
          </el-col>
          <el-col :span="20">
            <div style="">今回予約情報</div>
          </el-col>
        </el-row>

        <div v-for="item in newList">
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">搬入予約日</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{item.reserved_ymd}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">夜間連絡先</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{item.truck_tel}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">予約番号</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll">
            <div class="jyohouShow-text">{{item.reserved_id}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">搬入品目</div>
              </el-col>
            </el-row>

          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll" v-if="item.item_type_name.length > 15">
            <el-tooltip placement="top-start">
              <div slot="content" class="item">{{item.item_type_name}}</div>
              <div class="jyohouShow-text" style="text-overflow:ellipsis">{{item.item_type_name}}</div>
            </el-tooltip>
          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll" v-else="item.item_type_name.length <= 15">
              <div class="jyohouShow-text">{{item.item_type_name}}</div>
          </el-col>

        </el-row>
        <el-row class="jyohouShow-row">
          <el-col :span="8" class="jyohouShow-label-small">

            <el-row style="width: 140px">
              <el-col :span="24">
                <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <div style="width: 140px">トラック形状</div>
              </el-col>
            </el-row>

          </el-col>

          <el-col :span="16" class="jyohouShow-input-samll" v-if="item.truck_type_name.length > 15">
            <el-tooltip placement="top-start">
              <div slot="content" class="item">{{item.truck_type_name}}</div>
              <div class="jyohouShow-text" style="text-overflow:ellipsis">{{item.truck_type_name}}</div>
            </el-tooltip>
          </el-col>
          <el-col :span="16" class="jyohouShow-input-samll" v-else="item.truck_type_name.length <= 15">
            <div class="jyohouShow-text">{{item.truck_type_name}}</div>
          </el-col>

        </el-row>
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">備考</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll">
              <div class="jyohouShow-text">{{item.prepare}}</div>
            </el-col>

          </el-row>
        </div>

        <el-row class="jyohouShow-row">
          <el-col :span="4" style="padding: 0.4em 0em 1.2em 3em">
            <div style=""></div>
          </el-col>
          <el-col :span="20">
            <div style="">前回予約情報</div>
          </el-col>
        </el-row>
        <div v-for="item in oldList">
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">搬入予約日</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll">
              <div class="jyohouShow-text">{{item.reserved_ymd}}</div>
            </el-col>

          </el-row>
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">夜間連絡先</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll">
              <div class="jyohouShow-text">{{item.truck_tel}}</div>
            </el-col>

          </el-row>
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">予約番号</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll">
              <div class="jyohouShow-text">{{item.reserved_id}}</div>
            </el-col>

          </el-row>
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">搬入品目</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll" v-if="item.item_type_name === null || item.ITEM_TYPE_NAM === ''">
              <div class="jyohouShow-text">{{item.item_type_name}}</div>
            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll" v-else-if="item.item_type_name.length > 15">
              <el-tooltip placement="top-start">
                <div slot="content" class="item">{{item.item_type_name}}</div>
                <div class="jyohouShow-text" style="text-overflow:ellipsis">{{item.item_type_name}}</div>
              </el-tooltip>
            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll" v-else="item.item_type_name.length <= 15">
              <div class="jyohouShow-text">{{item.item_type_name}}</div>
            </el-col>

          </el-row>
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">トラック形状</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll" v-if="item.truck_type_name === null || item.truck_type_name === ''">
              <div class="jyohouShow-text">{{item.item_type_name}}</div>
            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll" v-else-if="item.truck_type_name.length > 15">
              <el-tooltip placement="top-start">
                <div slot="content" class="item">{{item.truck_type_name}}</div>
                <div class="jyohouShow-text" style="text-overflow:ellipsis">{{item.truck_type_name}}</div>
              </el-tooltip>
            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll" v-else="item.truck_type_name.length <= 15">
              <div class="jyohouShow-text">{{item.truck_type_name}}</div>
            </el-col>

          </el-row>
          <el-row class="jyohouShow-row">
            <el-col :span="8" class="jyohouShow-label-small">

              <el-row style="width: 140px">
                <el-col :span="24">
                  <div style=" font-size: 8px;font-weight: 800;padding:2px 6px 2px 6px;"></div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div style="width: 140px">備考</div>
                </el-col>
              </el-row>

            </el-col>
            <el-col :span="16" class="jyohouShow-input-samll">
              <div class="jyohouShow-text">{{item.prepare}}</div>
            </el-col>

          </el-row>
        </div>
        </div>
        <el-row >
          <el-col :span="12">
            <el-button type="danger" class="show-btn-left" @click.native.prevent="complete()">登録完了</el-button>
          </el-col>
          <el-col :span="12">
            <el-button type="danger" class="show-btn-right"  @click.native.prevent="continues()">登録継続</el-button>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'

  export default {
    data() {
      return {
        title: '',
        systemName: '夜間搬入申込サービス',
        yoyakuCode: '予約番号一覧',
        oldList: [],
        oldDate: '',
        newList: [],
        userId: '',
        clientId: '',
        namesei: '',
        namemei: '',
        companyName: '',
        truckCompName: '',
        truckTelSiban: '',
        truckTelKaiban: '',
        truckTelKyoKuBan: '',
        errorMsg: ''
      }
    },
    methods: {
      complete() {
        this.resetCommonData('/customer/search')
        _g.toastMsg('warning', '取引先公開 夜間産廃搬入状況画面へ遷移しました！')
      },
      continues() {
        var clientId = window.localStorage.getItem('userId')
        this.$router.push({ path: '/customer/informationInputDetail', query: { clientId: clientId, truckCompName: this.truckCompName, truckTelSiban: this.truckTelSiban, truckTelKaiban: this.truckTelKaiban, truckTelKyoKuBan: this.truckTelKyoKuBan }})
      }
    },
    created() {
      let data = {}
      this.oldDate = this.$route.query.oldDate
      data.clientId = this.$route.query.userId
      this.truckTelSiban = this.$route.query.truckTelSiban
      this.truckTelKaiban = this.$route.query.truckTelKaiban
      this.truckTelKyoKuBan = this.$route.query.truckTelKyoKuBan
      this.errorMsg = this.$route.query.errorMsg
      this.apiPost('customer/InformationInput/selectDetail', data).then((res) => {
        this.handelResponse(res, (data) => {
          this.newList = data
        })
      })
      data.oldDate = this.oldDate
      this.apiPost('customer/InformationInput/oldDetail', data).then((res) => {
        this.handelResponse(res, (data) => {
          this.oldList = data
        })
      })
      data.reservedId = this.$route.query.reservedId
      this.apiPost('customer/InformationInput/index', data).then((res) => {
        this.handelResponse(res, (data) => {
          this.clientId = data.client_id
          this.namesei = data.contact_name_sei
          this.namemei = data.contact_name_mei
          this.companyName = data.company_name
          this.truckCompName = data.truck_comp_name
        })
      })
    },
    mounted() {
      window.addEventListener('keyup', (e) => {
        if (e.keyCode === 13) {
          this.handleSubmit2()
        }
      })
    },
    mixins: [http]
  }
</script>

<style>
  .show-btn-left{
    margin-top: 1em;
    float: right;
    width: 150px;
  }
  .show-btn-right{
    margin-top: 1em;
    margin-left: 20px;
    width: 150px;
    float: left;
  }

  .jyohouShow-text{
    margin: 10px;
    white-space:nowrap;
    width:23em;
    overflow:hidden;
  }
  .jyohouShow-row{
    margin-bottom: 0.1em;
  }
  .jyohouShow-input-samll{
    height: 40px;
    background-color:#F5F7F7;
  }
  .item {
    width: 200px;
  }
  .jyohouShow-label-small{
    height: 40px;
    padding: 0.4em 0em 1.2em 3em;
    background-color:#E2EBFF;
  }
  .card-box-Show {
    padding: 1em;
  }
  .show-msg {
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 1em auto;
    width: 42em;
    border: 0.1em solid #8492A6;
  }
  .show-name{
    text-align: right;
    padding: 0.5em;
    font-weight: bold;
    font-size: 1.3em;
  }
  .thistitle {
    color: #505458;
    font-weight: bold;
    font-size: 1.17em;
    padding: 0em 0em 1em 0.5em;
  }

</style>



// WEBPACK FOOTER //
// src/components/customer/informationInputShow.vue